import { ExclusionListItem } from '../../exclusionsPanel/types';

export interface ExclusionListSelectorWebComponentSchema {
  disabled: boolean;
  selectedTarget: ExclusionListItem;
  list: Array<ExclusionListItem>;
}

export interface ExclusionListData {
  _id: string;
  name: string;
  description: string;
}

export interface ExclusionListResponse {
  data: Array<ExclusionListData>;
  success: boolean;
}

export enum RpcAction {
  EXCLUSION_LISTS = "ExclusionLists",
}

export enum RpcExclusionListsMethod {
  GET_COMPANY_LISTS_FOR_TYPE = "getCompanyListsForType",
}
